let mode='';
let epoch=0;
export const verifiedMode=()=>mode;
export const modeEpoch=()=>epoch;
export function setVerifiedMode(next){
  if(!['production','test','demo'].includes(next)||next===mode)return;
  mode=next;epoch+=1;
  window.dispatchEvent(new CustomEvent('env:changed',{detail:{env:next}}));
}
export const isCustomerPage=(path=window.location.pathname)=>/^\/(order|self-order)(\/|$)|^\/public\/menu(\/|$)|^\/(pay|track|feedback)\//i.test(path);
export function customerPreviewToken(){
  if(!isCustomerPage())return '';
  try{
    const incoming=new URLSearchParams(window.location.search).get('preview');
    if(incoming)sessionStorage.setItem('cc.customer-preview',incoming);
    return sessionStorage.getItem('cc.customer-preview')||'';
  }catch{return '';}
}
export function rememberCustomerToken(order){
  if(!order?.order_number||!order.customer_payment_token)return;
  try{localStorage.setItem(`cc.order-access:${order.env||verifiedMode()}:${order.order_number}`,order.customer_payment_token);}catch{}
}
export function customerTrackerPath(number){return `/track/${encodeURIComponent(number)}?token=${encodeURIComponent(customerOrderToken(number))}`;}
export function customerOrderToken(number){
  const query=new URLSearchParams(window.location.search).get('token');
  if(query)return query;
  try{return localStorage.getItem(`cc.order-access:${verifiedMode()}:${number}`)||'';}catch{return '';}
}
